module.exports = __webpack_public_path__ + "static/roadmunk-logo-7487439421a609288e3ed7169e7e911b.svg";